/**
 * API Client
 * Main interface that combines REST and GraphQL operations
 * Drop-in replacement for Amplify API
 */

import { get, post, put, del } from './restClient';
import { graphql } from './graphqlClient';

/**
 * API object that matches Amplify API interface
 */
export const API = {
  get,
  post,
  put,
  del,
  graphql
};

export default API;
